var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menuc" }, [
    _c(
      "div",
      {
        staticClass: "textc",
        style: _vm.textStyle,
        on: {
          click: function ($event) {
            return _vm.fTextClick()
          },
        },
      },
      [
        _c("span", { staticClass: "text" }, [_vm._v(_vm._s(_vm.selectedText))]),
        _c("span", {
          staticClass: "symbol",
          class: [_vm.bShow ? "symbol-up" : "symbol-down"],
        }),
      ]
    ),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.bShow,
            expression: "bShow",
          },
        ],
        staticClass: "menus",
      },
      _vm._l(_vm.aMenu, function (item, index) {
        return _c(
          "li",
          {
            key: "cmenu" + index,
            staticClass: "menu-item",
            class: { active: item.value == _vm.selectedValue },
            style: { width: _vm.menuWidth },
            on: {
              click: function ($event) {
                return _vm.fSelect(item)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(item.text) + "\n    ")]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }